export enum ALERT_TYPES {
	Success,
	Error,
	Info,
	Warning
}
